import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonsService } from 'src/app/services/commons.service';

@Component({
  standalone: false,
  selector: 'app-faqs-client',
  templateUrl: './faqs-client.component.html',
  styleUrls: ['./faqs-client.component.scss']
})
export class FaqsClientComponent implements OnInit {

  dataAccess: any;
  constructor(private readonly translation: TranslateService, private readonly c: CommonsService) { }

  ngOnInit() {
    this.translation.get(['FAQS.ANSWERS', 'FAQS.QUESTIONS']).subscribe(data => {
      this.dataAccess = data['FAQS.QUESTIONS'];
    });
  }

  datanicals = (i) => {
    this.c.eventsAnalitics('click', 'FAQs', i.value);
  }

}
